import api from "../service/obrasParticulares.service";
import * as types from "./obrasParticulares.actionTypes";
import formActions from "@common/store/form/form.actions";
import { takeEvery, call, put, select } from "redux-saga/effects";

//Actions
import decaActions from "./obrasParticulares.actions";
import uploadActions from "@common/components/upload/store/upload.actions";

import focusHelper from "@common/helpers/focus.helper";

export default workSaga;

function* workSaga() {
}
